import type { I18nLocale } from '#/i18n/types/I18nLocale';
import type { RadiusType } from '#/modules/search/helpers/radius';
import { searchEventsRoutePathByLocale } from '#/modules/search/routing/search.route-paths';
import { searchEventsRouteReference } from '#/modules/search/routing/search.routes';
import type { SearchEventFiltersByName } from '#/modules/search/types/FiltersByName/SearchEventFiltersByName';
import type { SearchSortType } from '#/modules/search/types/SearchSortType';

import { searchGetQueryParamsFromFiltersByName } from './searchGetQueryParamsFromFiltersByName';

type Args = {
  locale: I18nLocale;
  q?: string;
  radius?: RadiusType | string | null;
  filtersByName?: Omit<SearchEventFiltersByName, 'type'>;
  sort?: SearchSortType;
  pageIndex?: number;
};

export function searchGetEventsRoutePath({
  locale,
  filtersByName,
  q,
  radius,
  sort,
  pageIndex,
}: Args) {
  const queryParams = searchGetQueryParamsFromFiltersByName(filtersByName);
  if (q) queryParams.q = q;
  if (radius) queryParams.radius = radius;
  if (sort && sort !== 'relevance') queryParams.sort = sort;
  if (pageIndex) queryParams.page = pageIndex + 1;

  return searchEventsRouteReference
    .with(queryParams)
    .replace('/-lang/-segment', searchEventsRoutePathByLocale[locale]);
}
